import { render } from "./hobbiesPage.vue?vue&type=template&id=518ba478"
import script from "./hobbiesPage.vue?vue&type=script&lang=js"
export * from "./hobbiesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__